export default __webpack_public_path__ + "static/media/logo-text.2dc05b65.png";